import * as React from 'react';
import { useLayoutEffect, useRef } from 'react';
import Tabs, { type TabsProps, type TabsActions } from '@mui/material/Tabs';

/**
 * Re-syncs the MUI tab ink indicator after layout. Parent `zoom` (app shell) and async `value`
 * updates can otherwise leave the indicator under the wrong tab.
 */
export default function SyncedTabs(props: TabsProps) {
  const actionsRef = useRef<TabsActions | null>(null);
  const { action: _ignoredAction, value, ...rest } = props;

  useLayoutEffect(() => {
    const run = () => actionsRef.current?.updateIndicator();
    const id = requestAnimationFrame(run);
    return () => cancelAnimationFrame(id);
  }, [value]);

  useLayoutEffect(() => {
    const run = () => actionsRef.current?.updateIndicator();
    window.addEventListener('resize', run);
    return () => window.removeEventListener('resize', run);
  }, []);

  return <Tabs {...rest} value={value} action={actionsRef} />;
}
